<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            lịch hẹn</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <label>Họ và tên:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input clearable placeholder="Họ và tên..." v-model="search.cHoVaTen" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <label>Số điện thoại:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input clearable placeholder="Số điện thoại..." v-model="search.cSdt" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <label>Ngày hẹn:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-date-picker type="date" style="width: 100%;" placeholder="Ngày hẹn..." v-model="search.dNgayHen" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <label>Phòng ban:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-select clearable placeholder="Phòng ban..." v-model="search.nPhongBan">
                  <el-option label="Tất cả" value="" selected></el-option>
                  <el-option v-for="item in PhongBans" :value="item.nMaPhongBan" :label="item.cTenPhongBan"
                    :key="item.nMaPhongBan"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Tất cả" v-model="search.nTrangThai">
                  <el-option label="Tất cả" value="" selected></el-option>=
                  <el-option label="Hoạt động" value="1" selected></el-option>
                  <el-option label="Đã xóa" value="0" selected></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <div class="col-md-6">
            <!-- <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd" data-bs-toggle="modal"
              data-bs-target="#modal_news">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm Lịch hẹn</span>
            </el-button> -->
          </div>
          <!-- <div class="col-md-6" style="text-align:right">
              <el-button plain icon="el-icon-refresh" size="small" style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
                v-loading.fullscreen.lock="isLoading"></el-button>
            </div> -->
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
            stripe highlight-current-row>
            <el-table-column prop="cHoVaTen" show-overflow-tooltip class="text-nowrap" label="Họ và tên">
            </el-table-column>
            <el-table-column prop="cSdt" show-overflow-tooltip class="text-nowrap" label="SĐT" align="center"
              width="120">
              <template #default="scope">
                {{ scope.row.cSdt }}
              </template>
            </el-table-column>
            <el-table-column prop="cTenPhongBan" show-overflow-tooltip class="text-nowrap" label="Tên phòng ban">
              <template #default="scope">
                {{ getTenPhongBan(scope.row.nPhongBan) }}
              </template>
            </el-table-column>
            <el-table-column prop="dNgayHen" show-overflow-tooltip class="text-nowrap" label="Ngày hẹn" align="center"
              width="120">
              <template #default="scope">
                {{ momentDate(scope.row.dNgayHen) }}
              </template>
            </el-table-column>
            <el-table-column prop="nSoThuTu" show-overflow-tooltip class="text-nowrap" label="STT" align="center"
              width="120">
            </el-table-column>
            <el-table-column prop="dNgayTao" label="Ngày tạo" align="center" width="120">
              <template #default="scope">
                {{ momentDate(scope.row.dNgayTao) }}
              </template>
            </el-table-column>
            <el-table-column prop="nTrangThai" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.nTrangThai == 1" size="small">Hoạt động</el-tag>
                <el-tag type="danger" v-if="scope.row.nTrangThai == 0" size="small">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Hành động" align="center" width="150">
              <template #default="scope">
                <el-button plain type="primary" :disabled="scope.row.nTrangThai == 0" data-bs-toggle="modal"
                  data-bs-target="#modal_news" @click="handleOpenEdit(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                </el-button>
                <el-button plain type="danger" :disabled="scope.row.nTrangThai == 0"
                  v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <div class="modal fade" id="modal_news" ref="newsModalRef" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-1000px">
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="modal_news_header">
            <!--begin::Modal title-->
            <h2 class="fw-bolder">{{ !operation ? "Thêm lịch hẹn" : "Cập nhật lịch hẹn" }}</h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <div class="modal-body mh-600px overflow-scroll">
            <el-form :model="formData" :rules="rules" ref="formDataRef" label-width="120px" class=" d-flex flex-column">
              <el-form-item label="Họ và tên" prop="cHoVaTen">
                <el-input v-model="formData.cHoVaTen" />
              </el-form-item>
              <el-form-item label="Số điện thoại" prop="cSdt">
                <el-input v-model="formData.cSdt" />
              </el-form-item>
              <el-form-item label="Phòng ban" prop="nPhongBan">
                <el-select v-model="formData.nPhongBan">
                  <el-option v-for="item in PhongBans" :value="item.nMaPhongBan" :label="item.cTenPhongBan"
                    :key="item.nMaPhongBan"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Ngày hẹn" prop="dNgayHen">
                <el-date-picker type="date" v-model="formData.dNgayHen" />
              </el-form-item>
              <el-form-item label="Nội dung" prop="cNoiDung">
                <el-input type="textarea" v-model="formData.cNoiDung" />
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <div class="btn-group">
              <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Thêm</el-button>
              <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Lưu</el-button>
              <el-button plain type="danger" @click="handleClose">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="dialogVisible" class="bg-transparent w-auto shadow-none">
      <img class="mh-500px mw-1000px" :src="dialogImageUrl" alt="Preview Image" />
    </el-dialog>
  </div>
</template>
<script>
import { Appointment, Department } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import ImageResize from "quill-image-resize";
import { baseUrl } from "@/utils/global";
import { QuillEditor, Quill } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { ElMessage } from "element-plus";

Quill.register("modules/imageResize", ImageResize);

export default {
  name: 'Appointment',
  components: {
    QuillEditor
  },
  data() {
    return {
      search: {
        cHoVaTen: null,
        cSdt: null,
        dNgayHen: null,
        nPhongBan: null,
        nTrangThai: null,
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      formData: {
        nMaLichHen: null,
        cHoVaTen: null,
        cSdt: null,
        nPhongBan: null,
        dNgayHen: null,
        cNoiDung: null,
        nTrangThai: 1,
      },
      rules: {
        cHoVaTen: [{ required: true, message: "Xin vui lòng điền họ và tên", trigger: "blur" }],
        cSdt: [{ required: true, message: "Xin vui lòng điền số điện thoại", trigger: "blur" }],
        nPhongBan: [{ required: true, message: "Xin vui lòng chọn phòng ban", trigger: "blur" }],
        dNgayHen: [{ required: true, message: "Xin vui lòng chọn ngày hẹn", trigger: "blur" }],
      },
      tableData: {
        content: [{}]
      },
      PhongBans: [],
      isLoading: false,
      modalVisible: false,
      operation: false,
      iframeURL: "",
      openIframe: false,
      isSearchLoading: false,
      store: useStore(),
      dialogImageUrl: null,
      dialogVisible: false,
    }
  },
  methods: {
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleOpenAdd() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = false
      this.formData = {}
      this.$refs.quillEditor.setHTML("")
    },
    handleOpenEdit(val) {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = true
      this.operation = true
      this.formData = Object.assign({}, val)
      this.$refs.quillEditor.setHTML(val.cNoiDung)

    },
    handleClose() {
      this.$refs.formDataRef.resetFields()
      this.modalVisible = false
      hideModal(this.$refs.newsModalRef)
    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa lịch hẹn này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(Appointment.deleteAppointment, val.nMaLichHen).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa lịch hẹn thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa lịch hẹn thất bại", type: "error" });
          })
        }).catch(() => {

        })
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        cHoVaTen: { value: this.search.cHoVaTen },
        cSdt: { value: this.search.cSdt },
        dNgayHen: { value: this.momentDate(this.search.dNgayHen) },
        nPhongBan: { value: this.search.nPhongBan },
        nTrangThai: { value: this.search.nTrangThai },
      }
      this.store.dispatch(Appointment.findPageAppointment, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      }).catch((error) => {
        ElMessage({ message: "Tìm lịch hẹn thất bại", type: "error" });
      })
    },
    handleSave() {
      this.$refs.formDataRef.validate((valid) => {
        if (valid)
          this.$confirm("Bạn có muốn lưu lịch hẹn này không?", "Xác nhận", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy",
            type: "warning",
          }).then(() => {

            const formData = new FormData()
            formData.append("record", new Blob([JSON.stringify(this.formData)], { type: "application/json" }))
            if (this.operation) {
              this.store.dispatch(Appointment.saveAppointment, this.formData).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Cập nhật lịch hẹn thành công", type: "success" })
                } else {
                  ElMessage({ message: "Cập nhật lịch hẹn không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Cập nhật lịch hẹn không thành công", type: "error" })
              })
            } else {
              this.store.dispatch(Appointment.saveAppointment, this.formData).then(res => {
                if (res.code == 200) {
                  this.handleFindPage()
                  this.handleClose()
                  ElMessage({ message: "Thêm lịch hẹn mới  thành công", type: "success" })
                } else {
                  ElMessage({ message: "Thêm lịch hẹn mới không thành công", type: "error" })
                }
              }).catch(() => {
                ElMessage({ message: "Thêm lịch hẹn mới không thành công", type: "error" })
              })
            }
          }).catch(() => {

          })
      })
    },
    handleGetPhongBan() {
      this.store.dispatch(Department.listDepartment, { pageSize: 500, pageNum: 1 }).then(res => {
        if (res.code == 200) {
          this.PhongBans = res.data.content
        } else {
          ElMessage({ message: "Lấy danh sách phòng banthất bại", type: "error" });
        }
      }).catch((error) => {
        ElMessage({ message: "Lấy danh sách phòng ban thất bại", type: "error" });
      })
    },
    getTenPhongBan(val) {
      const phongBan = this.PhongBans.find(item => item.nMaPhongBan == val)
      return phongBan ? phongBan.cTenPhongBan : ""
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
  },
  mounted() {
    this.handleFindPage()
    this.handleGetPhongBan()
  }
};
</script>
<style lang="scss"></style>